<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-btn color="primary" dark class="mb-2" @click="btnAccountManagement()"> {{$t("ProfilePage.btnAccountManagementTitle")}} </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>



export default {
  name: "AccountSettings",
  components: {  },
  data() {
    return {
    }
  },
  methods: {
    async btnAccountManagement() {
      // const result = await this.$refs.DialogChangePassword.show({})
      // console.log(result)
      // if (result.answer === "positive") {
      //   console.log('ChangePassword', result.oldPassword, result.newPassword)
      //   await this.apiBackendChangePassword({oldpassword: result.oldPassword, newpassword: result.newPassword})
      // }
      window.keycloak.accountManagement()

    },
  },
  watch: {
  },
  computed: {
  },

  created() {
  },
}
</script>
